export { default } from "@vendors/CreativeTim/components/CustomInput/CustomInput.js";
